export default "__VITE_ASSET__15a0bbcb__"